<template>
    <div id="saveSuccessfully1">
      <div class="mainHead">
        <div class="route">
          <span class="crumbs"></span><span class="link" @click="returnBtn()">建筑管理</span><span class="arrow">></span><span>删除成功</span>
        </div>
        <div> 
          <el-button type="primary" @click="returnBtn">返回</el-button>
        </div>
      </div>
      <div class="fixedScroll" :style="{height: heightCard + 'px'}">
        <div class="maindetails">
            <div class="save">
                <div class="saveIcon"><img :src="deleted" alt=""><span>删除成功!</span></div>
                <div class="savetimer">( {{count}} ) 秒后自动返回建筑管理</div>
                <div class="saveBtn">
                    <div @click="returnBtn2"><el-button type="primary">立刻返回建筑管理</el-button></div>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
    import TopNav from "@/components/TopNav";
    import LeftNav from "@/components/LeftNav";
    import {ajaxFuncJson} from '@/api/ajax';
    export default {
        name: 'saveSuccessfully1',
        components: {
          TopNav,
          LeftNav
        },
        data() {
            return {
                heightCard:'',
                flag: false, // 判断时保存还是删除true保存 false删除
                count:'',
                save: '/static/img/save.png',
                deleted: './static/img/delete.png',
                floorid: '',
                floorListData: [],
            }
        },
        created() {
            // this.flag = this.$route.query.flag;

                this.del();
            sessionStorage.setItem('sav','')

        },
        mounted() {
            let that = this;
            function initFont() {
                that.heightCard = $(document.body).height() - $('.el-header').outerHeight(true)- $('.mainHead').outerHeight(true) -20;
                that.heightBg =  that.heightCard -$('.maindetails').outerHeight(true);
            }initFont();
            $(window).resize(initFont);
        },
        methods: {
        getBuilding() {
            let params = {
                buildingName: ''
            }
            ajaxFuncJson('/basicData/getBuilding',params).then(res=>{
                // 查询建筑列表
                sessionStorage.setItem('leftData',JSON.stringify(res.data.data));
                this.$store.dispatch('getLeftDataList',res.data.data)
            });
        },
            settime(){
                const TIME_COUNT = 5;
                if(!this.timer){
                    this.count = TIME_COUNT;
                    this.timer = setInterval(()=>{
                        if(this.count > 0 && this.count <= TIME_COUNT){
                            this.count--;
                        }else{
                            clearInterval(this.timer);
                            this.timer = null;
                            this.roteAdd()
                            this.getBuilding();//左侧
                        }
                    },1000)
                }
            },
            del(){
                const TIME_COUNT = 5;
                if(!this.timer){
                    this.count = TIME_COUNT;
                    this.timer = setInterval(()=>{
                        if(this.count > 0 && this.count <= TIME_COUNT){
                            this.count--;
                        }else{
                            clearInterval(this.timer);
                            this.timer = null;
                             this.roteAdd()
                            this.getBuilding();//左侧
                        }
                    },1000)
                }
            },
            returnBtn(){ //返回按钮;
                clearInterval(this.timer);
                this.timer = null;
                this.$router.push({path:'/content/editBuliting'}); //监测点首页
                this.getBuilding();//左侧
            },
            returnBtn2(){ //返回按钮;
                clearInterval(this.timer);
                this.getBuilding();//左侧
                this.roteAdd()
            },
            roteAdd(){ //新增监测点
                let from = {
                    buildingName: '',
                    area: '',
                    address: [],
                    onFloor: '',
                    underFloor: '',
                    coverArea: '',
                    detailAddress: '',
                }
                sessionStorage.setItem('editBulitData',JSON.stringify(from));
                this.$store.state.editBulitData = from;
                sessionStorage.setItem('saveBtn',true);
                this.$store.state.saveBtn = true;
                this.$store.state.menuS = sessionStorage.getItem('customerId');
                sessionStorage.setItem('menuS',sessionStorage.getItem('customerId'))
                this.$router.push({path:'/content/editBuliting'}); //进入非监测点详情
            },
            roteView(){ //查看监测点信息
                let _this = this;
                let params = {
                    buildingId: sessionStorage.getItem('editbuiltID'),
                }
                ajaxFuncJson('/basicData/selectByPrimaryKey',params).then(res=>{
                    if (res.data.status == 200) {
                        if (res.data.data.area == 0) {
                            res.data.data.area = ''
                        }
                        if (res.data.data.coverArea == 0) {
                            res.data.data.coverArea = ''
                        }
                        res.data.data.address = res.data.data.address.split('|');
                        sessionStorage.setItem('editbuiltID',res.data.data.id);    // 缓存编辑建筑id
                        _this.$store.state.menuS = res.data.data.id;
                        sessionStorage.setItem('menuS',res.data.data.id);
                        sessionStorage.setItem('saveBtn',false);
                        _this.$store.state.saveBtn = false;
                        sessionStorage.setItem('editBulitData',JSON.stringify(res.data.data));
                        _this.$store.state.editBulitData = res.data.data;
                        _this.$router.push({path:'/content/editBuliting'});
                        clearInterval(this.timer);

                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">
@import "@/assets/css/mixin.scss";
// 内容布局
.el-main{
  width: 78.1%;
  margin:10px 0 7px 1.05%;
  padding: 0;
  .maindetails{
      height: 100%;
      padding-top: 145px;
      margin-right: 1.05%;
      background-color:#fff;
  }
}
.save{
    .saveIcon{
        @include flexible;
        @include alignItems(center);
        @include justify(center);
        font-size: 28px;
        color: #4caf50;
        font-weight: bold;
        &>span{
            margin-left: 10px;
            display: inline-block;
            vertical-align: middle
        }
        img{
            width: 36px;
            height: 36px;
        }
    
    }
    .saveBtn{
        margin-top: 60px;
        @include flexible;
        @include alignItems(center);
        @include justify(center);
        .el-button{
            width: 200px;
            height: 40px;
            padding: 0;
            font-size: 16px !important;
        }
        &>div{
            margin-right: 20px;
            &:last-child{
                margin-right: 0;
            }
        }
    }
}
.savetimer{
        margin-top: 20px;
        font-size: 13px;
        color: #282828;
        @include flexible;
        @include alignItems(center);
        @include justify(center);
    }

</style>


// WEBPACK FOOTER //
// src/page/BasicData/delSuccessfully1.vue